import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";

function ownKeys(object, enumerableOnly) {
  var keys = _Object$keys(object);

  if (_Object$getOwnPropertySymbols) {
    var symbols = _Object$getOwnPropertySymbols(object);

    if (enumerableOnly) symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) {
      return _Object$getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      var _context;

      _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (_Object$getOwnPropertyDescriptors) {
      _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source));
    } else {
      var _context2;

      _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) {
        _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { detectSeries } from './async';

require('colors');

var Storage = {};
Storage.Providers = {};
Storage.noProviderError = 'Storage provider not set; e.g EmbarkJS.Storage.setProvider("ipfs")';

Storage.saveText = function (text) {
  if (!this.currentStorage) {
    throw new Error(this.noProviderError);
  }

  return this.currentStorage.saveText(text);
};

Storage.get = function (hash) {
  if (!this.currentStorage) {
    throw new Error(this.noProviderError);
  }

  return this.currentStorage.get(hash);
};

Storage.uploadFile = function (inputSelector) {
  if (!this.currentStorage) {
    throw new Error(this.noProviderError);
  }

  return this.currentStorage.uploadFile(inputSelector);
};

Storage.getUrl = function (hash) {
  if (!this.currentStorage) {
    throw new Error(this.noProviderError);
  }

  return this.currentStorage.getUrl(hash);
};

Storage.resolve = function (name, callback) {
  if (!this.currentStorage) {
    throw new Error(this.noProviderError);
  }

  return this.currentStorage.resolve(name, callback);
};

Storage.register = function (addr, callback) {
  if (!this.currentStorage) {
    throw new Error(this.noProviderError);
  }

  return this.currentStorage.register(addr, callback);
};

Storage.registerProvider = function (providerName, obj) {
  this.Providers[providerName] = obj;
};

Storage.setProvider = function (providerName, options) {
  var provider = this.Providers[providerName];

  if (!provider) {
    if (providerName === 'ipfs') {
      console.log("the embarkjs-ipfs package might be missing from your project dependencies");
    }

    if (providerName === 'swarm') {
      console.log("the embarkjs-swarm package might be missing from your project dependencies");
    }

    throw new Error('Unknown storage provider: ' + providerName);
  }

  this.currentProviderName = providerName;
  this.currentStorage = provider;
  return provider.setProvider(options);
};

Storage.isAvailable = function () {
  if (!this.currentStorage) {
    return _Promise.resolve(false);
  }

  return this.currentStorage.isAvailable();
}; // TODO: most of this logic should move to the provider implementations themselves


Storage.setProviders = function (dappConnOptions, addlOpts) {
  var self = this;
  detectSeries(dappConnOptions, function (dappConn, callback) {
    var options = dappConn;
    if (dappConn === '$BZZ') options = {
      "useOnlyGivenProvider": true
    };
    options = _objectSpread({}, options, {}, addlOpts, {}, dappConn);

    try {
      self.setProvider(dappConn === '$BZZ' ? dappConn : dappConn.provider, options).then(function () {
        self.isAvailable().then(function (isAvailable) {
          callback(null, isAvailable);
        }).catch(function () {
          callback(null, false);
        });
      }).catch(function () {
        callback(null, false); // catch errors for when bzz object not initialised but config has requested it to be used
      });
    } catch (err) {
      callback(null, false);
    }
  }, function (err, result) {
    if (!result) console.log('Could not connect to a storage provider using any of the dappConnections in the storage config'.red);
  });
};

export default Storage;